export default __webpack_public_path__ + "static/media/rocket_anim_159.21f865c0.png";